import Toasted from "vue-toasted";
import Vue from "vue";
import store from "@/store";
import { SHOW_OVERLAY } from "@/store/actions/actions.type";

export const toastDefaultOptions = {
  position: "bottom-center",
  duration: 5000,
  addCloseButton: false,
  keepOnHover: true,
  fullWidth: true,
  fitToScreen: true,
  iconPack: "custom-class",
  containerClass: "toast-b42-container",
  className: "toast-b42",
  type: "primary"
};

const addCloseButton = toast => {
  // create a close button
  let close = document.createElement("button");
  close.innerHTML = "&times;";
  close.className = "toasted-close";

  // add eventListener to close the toast
  close.addEventListener("click", () => {
    closeToast(toast);
  });

  // append the close button to the toast
  toast.el.appendChild(close);
};

const closeToast = toast => {
  if (toast.goAway(0)) {
    store.dispatch(`application/${SHOW_OVERLAY}`, { showOverlay: false });
  }
};

const showToast = (msg, options) => {
  if (options.overlay) {
    store.dispatch(`application/${SHOW_OVERLAY}`, options.overlay);
  }
  const toast = Vue.toasted.show(msg, options);
  if (options.addCloseButton) {
    addCloseButton(toast);
  }
};

export const toast = {
  alert: (msg, options, detailsHtml = "") => {
    const html = `<div class="alert-msg">${msg}${detailsHtml}</div>`;
    showToast(html, { ...options });
  },
  confirm: (msg, options, detailsHtml = "") => {
    const html = `<div class="alert-msg">${msg}${detailsHtml}</div>`;
    showToast(html, {
      ...options,
      duration: null,
      closeOnSwipe: false
    });
  },
  close: toastObject => {
    closeToast(toastObject);
  }
};

export default Toasted;
